import {
    EMPLOYEE_LOADING,
    EMPLOYEE_ERRORS,
    FETCH_ADMINISTRATORS_SUCCESS,
    FETCH_HR_SUCCESS,
    FETCH_SUPERVISORS_SUCCESS,
    FETCH_ACCOUNT_MANAGERS_SUCCESS,
    FETCH_HELPERS_SUCCESS,
    FETCH_EMPLOYEES_SUCCESS,
    FETCH_EMPLOYEE_SUCCESS,
    FETCH_EMPLOYEE_AVAILABILITY_SUCCESS,
    FETCH_EMPLOYEE_COMMENTS_SUCCESS,
    REMOVE_SINGLE_EMPLOYEE,
    FETCH_EMPLOYEE_SCHEDULED_WORK_SUCCESS,
    FETCH_MERCHANDISERS_SUCCESS
} from "actions/types";

const initialState = {
    administrators: [],
    hr: [],
    supervisors: [],
    accountManagers: [],
    helpers: [],
    merchandisers: [],
    employees: [],
    singleEmployee: {},

    error: {},
    loading: false,
    accountManagerLoading: false
};

export default function(state = initialState, action) {
    let singleEmployee;
    switch (action.type) {
        case EMPLOYEE_LOADING:
            return {
                ...state,
                loading: true,
                error: {},
            };
        case EMPLOYEE_ERRORS:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        case FETCH_ADMINISTRATORS_SUCCESS:
            return {
                ...state,
                administrators: action.payload,
                loading: false
            };
        case FETCH_HR_SUCCESS:
            return {
                ...state,
                hr: action.payload,
                loading: false
            };
        case FETCH_SUPERVISORS_SUCCESS:
            return {
                ...state,
                supervisors: action.payload,
                loading: false
            };
        case FETCH_MERCHANDISERS_SUCCESS:
            return {
                ...state,
                merchandisers: action.payload,
                loading: false
            };
        case FETCH_ACCOUNT_MANAGERS_SUCCESS:
            return {
                ...state,
                accountManagers: action.payload,
                accountManagerLoading: false,
                loading: false
            };
        case FETCH_HELPERS_SUCCESS:
            return {
                ...state,
                helpers: action.payload,
                loading: false
            };
        case FETCH_EMPLOYEES_SUCCESS:
            return {
                ...state,
                employees: action.payload,
                loading: false
            };
        case FETCH_EMPLOYEE_SUCCESS:
            singleEmployee = Object.assign({}, state.singleEmployee);
            singleEmployee.ContactInfo = action.payload;
            return {
                ...state,
                singleEmployee,
                loading: false
            };
        case FETCH_EMPLOYEE_AVAILABILITY_SUCCESS:
            singleEmployee = Object.assign({}, state.singleEmployee);
            singleEmployee.Availability = action.payload;
            return {
                ...state,
                singleEmployee,
                loading: false
            };
        case FETCH_EMPLOYEE_COMMENTS_SUCCESS:
            singleEmployee = Object.assign({}, state.singleEmployee);
            singleEmployee.Comments = action.payload;
            return {
                ...state,
                singleEmployee,
                loading: false
            };
        case FETCH_EMPLOYEE_SCHEDULED_WORK_SUCCESS:
            singleEmployee = Object.assign({}, state.singleEmployee);
            singleEmployee.ScheduledWork = action.payload;
            return {
                ...state,
                singleEmployee,
                loading: false
            };
        case REMOVE_SINGLE_EMPLOYEE:
            return {
                ...state,
                singleEmployee: {},
                loading: false
            };
        default:
            return state;
    }
}
